module.exports = __webpack_public_path__ + "media/images/products/h1-b9a6d179205e75dc3020c6181ca99cc8.jpg";